/* global $ Intercom */

$('.trigger-intercom').on('click', e => {
    e.preventDefault()

    Intercom('show') // eslint-disable-line new-cap
})



/** WEBPACK FOOTER **
 ** ./js/lib/intercom.js
 **/